import { render, staticRenderFns } from "./announcement-notice.vue?vue&type=template&id=5ead6568&scoped=true"
import script from "./announcement-notice.vue?vue&type=script&lang=js"
export * from "./announcement-notice.vue?vue&type=script&lang=js"
import style0 from "./announcement-notice.vue?vue&type=style&index=0&id=5ead6568&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ead6568",
  null
  
)

export default component.exports